import axios from 'axios';
import { API_URL } from '../config/environment-variables';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { AUTH_USER } from './types';
import { fetchBusinessSalesStart, fetchEndpointAccess, fetchMachines, fetchUser } from './user-actions';
import { clearAuthenticationHeaders, clearOtherDataStoredInLocalStorage, setAuthenticationHeaders } from './utils';
import { clearAdministrationData } from './administration/administration-actions';
import { analyticEvent } from '../analytics';

export const LOCAL_STORAGE_MACHINE_ID = 'machineID';
export const LOCAL_STORAGE_TAX_POPUP = 'taxPopup';
export const LOCAL_STORAGE_SESSION_ID = 'sessionId';
export const LOCAL_STORAGE_USER_ID = 'userId';
export const LOCAL_STORAGE_SESSION_EXPIRES_KEY = 'sessionLifetime';
export const LOCAL_STORAGE_BUSINESS_START_TIME = 'businessStartTime';
export const LOCAL_STORAGE_ENDPOINT_ACCESS = 'endpointAccess';

function setErrorOnLoginForm(form) {
  form.setSubmitting(false);
  const formattedError = <FormattedMessage
    id="form.login.wrong.credentials.error"
    defaultMessage="Invalid username or password"
  />;
  form.setErrors({ username: formattedError, password: formattedError });
}

export function login(values, form) {
  const { username, password } = values;
  return dispatch =>
    axios.post(
      `${API_URL}/session/Authenticate?type=2`,
      {
        Username: username,
        Password: password,
      })
      .then(response => {
        analyticEvent('Authentication', 'Login', 'Success', { username: username });
  
        if (response.status === 200) {
          const responseData = response.data;
          setAuthenticationHeaders(responseData.Id, responseData.WebUserId, responseData.ExpiresDateTime);
          dispatch({
            type: AUTH_USER,
            payload: true,
          });
        } else {
          setErrorOnLoginForm(form);
        }
      }).then(() => {
      dispatch(fetchUser());
      dispatch(fetchEndpointAccess());
      dispatch(fetchBusinessSalesStart());
      dispatch(fetchMachines());
    })
      .catch(() => {
        analyticEvent('Authentication', 'Login', 'Failure', { username: username });
        setErrorOnLoginForm(form);
      });
}

export function logout() {
  return dispatch => {
    clearAdministrationData();
    clearAuthenticationHeaders();
    clearOtherDataStoredInLocalStorage();
    return dispatch({ type: AUTH_USER, payload: false });
  };
}